import ScrollList from "./index.vue";

const svgIconPlugin: any = {
  name: "ScrollList",
  install(app: any): void {
    app.component("ScrollList", ScrollList);
  }
};

export default svgIconPlugin;
